import { compose, withFieldValidation } from "@transformd-ltd/sdk";
import React, { useState, useCallback, useEffect } from "react";
import { diffYears, parseAplyidDate } from "../../javascript/common";
import { Button } from "antd";

const DATE_OF_BIRTH_APPLICANT1_FIELD_TAG = "dateOfBirth";

const FIELD_ID = "6292811d0fdd5f01120d0352";
const FIELD_TAG = "selectedProduct";

const ProductCards = ({ getData }) => {
  const [emitter, setEmitter] = useState(null);
  const handler = useCallback((eventData) => {
    // console.log("PRODUCT_CARDS_EMITTER: ", eventData);
  }, []);

  const onChange = (value) => {
    getData().setFieldValue(FIELD_ID, value);
  };

  const selectedValue = getData().getFieldValue(FIELD_ID);

  const applicant1DateOfBirth =
    getData().getFieldValue(DATE_OF_BIRTH_APPLICANT1_FIELD_TAG) || "01/01/2000"; // aply_dateOfBirth

  const applicant1Age = diffYears(
    new Date(),
    parseAplyidDate(applicant1DateOfBirth)
  );

  const showSuperCharge = applicant1Age < 30 && applicant1Age >= 18;

  // Instantiate emitter
  useEffect(() => {
    const myEmitter = getData().getEmitter();
    myEmitter.on("ValueChanged", handler);

    setEmitter(myEmitter);

    return () => {
      if (emitter) {
        emitter.off("*", handler);
      }
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {showSuperCharge && (
        <ProductCard4
          label="U30 SUPER CHARGE"
          onChange={onChange}
          selectedValue={selectedValue}
          featuresList={["Earn high interest", "No ongoing fees"]}
          src="https://www.policebank.com.au/transformd-new/assets-shared/images/super_charge_account.png"
          imageLink="https://www.policebank.com.au/u30-super-charge"
          description="Our U30 Super Charge Account is for members aged 18-29 and will have your money working harder helping you save faster."
          // buttonText="Select U30 Super Charge"
          // selectedButtonText="You Selected U30 Super Charge"
          buttonText="Select"
          selectedButtonText="Selected"
        />
      )}
      <ProductCard4
        label="Easy Access"
        onChange={onChange}
        selectedValue={selectedValue}
        featuresList={["No ongoing fees", "No min/max Balance"]}
        src="https://www.policebank.com.au/transformd-new/assets-shared/images/easy_access_account.png"
        imageLink="https://www.policebank.com.au/banking/easy-access-account"
        description="The Easy Access Account is our easy day-to-day account for your basic banking needs."
        // buttonText="Select Easy Access"
        // selectedButtonText="You Selected Easy Access"
        buttonText="Select"
        selectedButtonText="Selected"
      />
    </div>
  );
};

// Original Version
const ProductCard = ({
  label,
  onChange,
  selectedValue,
  featuresList = [],
  src = "",
  imageLink = "",
  description = "",
}) => {
  const checked = selectedValue === label;

  return (
    <div className="productcard">
      {/* Product Image */}
      <a href={imageLink}>
        <img
          src={src}
          className="product-image"
          alt={"View product information - " + label}
        />
      </a>
      {/* Product Radio */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <input
          type="radio"
          value={label}
          name="product"
          checked={checked}
          style={{ margin: 0, padding: 0, accentColor: "#0033bb" }}
          onChange={onChange}
        />
        <div
          style={{
            fontWeight: 700,
            marginLeft: 11,
            fontSize: 14,
            fontFamily: "DINPro",
            color: "black",
          }}
        >
          {label}
        </div>
      </div>
      {/* Features List */}
      <div style={{ paddingLeft: 31, marginBottom: 15 }}>
        {featuresList.map((feature) => (
          <div
            key={label + JSON.stringify(feature)}
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            <div style={{ color: "var(--pb-dark-blue-500)", fontSize: 14 }}>
              &#10003;
            </div>
            <div
              style={{
                marginLeft: 10,
                fontWeight: "normal",
                marginLeft: 11,
                fontSize: 14,
                fontFamily: "DINPro",
                color: "black",
              }}
            >
              {feature}
            </div>
          </div>
        ))}
      </div>
      <div>{description}</div>
    </div>
  );
};

// Alternate Version 1 -> Large heading, description text
const ProductCard2 = ({
  label,
  onChange,
  selectedValue,
  featuresList = [],
  src = "",
  imageLink = "",
  description = "",
}) => {
  const checked = selectedValue === label;

  return (
    <div className="productcard">
      {/* Product Image */}
      <a href={imageLink}>
        <img
          src={src}
          className="product-image"
          alt={"View product information - " + label}
        />
      </a>
      {/* Product Radio */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <input
          type="radio"
          value={label}
          name="product"
          checked={checked}
          style={{
            margin: 0,
            padding: 0,
            accentColor: "#0033bb",
          }}
          onChange={onChange}
        />
        <div
          style={{
            fontWeight: 700,
            marginLeft: 11,
            fontSize: 24,
            fontFamily: "DINPro",
            color: "black",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div style={{ height: 24 }}>{label}</div>
        </div>
      </div>
      <div style={{ marginBottom: 20, fontSize: 12 }}>{description}</div>
      {/* Features List */}
      <div
        style={{
          // paddingLeft: 31,
          marginBottom: 15,
        }}
      >
        {featuresList.map((feature) => (
          <div
            key={label + JSON.stringify(feature)}
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            <div style={{ color: "var(--pb-dark-blue-500)", fontSize: 14 }}>
              &#10003;
            </div>
            <div
              style={{
                marginLeft: 10,
                fontWeight: "normal",
                marginLeft: 11,
                fontSize: 14,
                fontFamily: "DINPro",
                color: "black",
              }}
            >
              {feature}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Alternate Version 2 -> No heading, radio button next to description text
const ProductCard3 = ({
  label,
  onChange,
  selectedValue,
  featuresList = [],
  src = "",
  imageLink = "",
  description = "",
}) => {
  const checked = selectedValue === label;

  return (
    <div className="productcard">
      {/* Product Image */}
      <a href={imageLink}>
        <img
          src={src}
          className="product-image"
          alt={"View product information - " + label}
        />
      </a>
      {/* Product Radio */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <input
          type="radio"
          value={label}
          name="product"
          checked={checked}
          style={{
            margin: 0,
            padding: 0,
            marginLeft: 11,
            marginRight: 22,
            accentColor: "#0033bb",
          }}
          onChange={onChange}
        />
        <div style={{ marginBottom: 20, fontSize: 12 }}>{description}</div>
      </div>
      {/* Features List */}
      <div
        style={{
          // paddingLeft: 31,
          marginBottom: 15,
        }}
      >
        {featuresList.map((feature) => (
          <div
            key={label + JSON.stringify(feature)}
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            <div style={{ color: "var(--pb-dark-blue-500)", fontSize: 14 }}>
              &#10003;
            </div>
            <div
              style={{
                marginLeft: 10,
                fontWeight: "normal",
                marginLeft: 11,
                fontSize: 14,
                fontFamily: "DINPro",
                color: "black",
              }}
            >
              {feature}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Alternate Version 3 -> No heading, uses button instead of radio
const ProductCard4 = ({
  label,
  onChange,
  selectedValue,
  featuresList = [],
  src = "",
  imageLink = "",
  description = "",
  buttonText = "",
  selectedButtonText = "",
}) => {
  const isSelected = selectedValue === label;

  return (
    <div
      className="productcard"
      style={{
        backgroundColor: isSelected ? "rgba(64,169,255,0.1)" : "white",
      }}
    >
      {/* Product Image */}
      <a href={imageLink}>
        <img
          src={src}
          className="product-image"
          alt={"View product information - " + label}
        />
      </a>
      <div style={{ marginBottom: 20, fontSize: 12 }}>{description}</div>
      {/* Features List */}
      <div
        style={{
          // paddingLeft: 31,
          marginBottom: 15,
        }}
      >
        {featuresList.map((feature) => (
          <div
            key={label + JSON.stringify(feature)}
            style={{ width: "100%", display: "flex", alignItems: "center" }}
          >
            <div style={{ color: "var(--pb-dark-blue-500)", fontSize: 14 }}>
              &#10003;
            </div>
            <div
              style={{
                marginLeft: 10,
                fontWeight: "normal",
                marginLeft: 11,
                fontSize: 14,
                fontFamily: "DINPro",
                color: "black",
              }}
            >
              {feature}
            </div>
          </div>
        ))}
      </div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Button
          disabled={isSelected}
          // block
          onClick={() => onChange(label)}
          // type={isSelected ? "ghost" : "default"}
          type="primary"
        >
          {isSelected ? selectedButtonText : buttonText}
        </Button>
      </div>
    </div>
  );
};

export default compose(withFieldValidation)(ProductCards);
